export default __webpack_public_path__ + "static/figma-export-a7f65d3486598f2e77cb91e68a6ccdf5.svg";